<template>
    <InfoDialog :visible="isModalVisibile" header="Nieautoryzowany token" :content="errorMessage"
                actionLabel="Zaloguj się" @close="redictToLogin" @accept="redictToLogin">
    </InfoDialog>

    <InfoDialog id="cancelRoutingDialog" :visible="routingCancelModal.isVisible" :header="routingCancelModal.header"
                :content="routingCancelModal.content"
                :actionLabel="routingCancelModal.label" @close="closeRoutingModal" @accept="closeRoutingModal">
    </InfoDialog>

    <Toast />
    <div :class="{ 'mainWrapper' : isLoggedIn}">
        <div class="navWrapper" v-if="isLoggedIn">
            <Nav></Nav>
        </div>
        <div class="headerWrapper" v-if="isLoggedIn">
            <Header></Header>
        </div>
        <div class="routerWrapper">
            <router-view :key="$route.fullPath"></router-view>
        </div>
    </div>
    <DynamicDialog />
</template>

<script>
import Nav from './views/Nav'
import Header from './views/Header'
import {onMounted, ref} from "vue";
import {axiosInstance} from "../../core/api/instance";
import {useRouter} from "vue-router";
import InfoDialog from "./components/InfoDialog";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import DynamicDialog from 'primevue/dynamicdialog';

export default {
    name: 'App',
    components: {
        Nav,
        Header,
        InfoDialog,
        Toast,
        DynamicDialog
    },
    setup() {
        const toast = useToast();
        const isModalVisibile = ref(false);
        const errorMessage = ref('');
        const router = useRouter();
        const routingCancelModal = ref({
            isVisible: false,
            header: '',
            content: '',
            label: '',
            redirectTo: ''
        });

        onMounted(function() {
            // === DEFAULT ERROR CALLBACK FUNCTION FOR WHOLE ADMIN SECTION ===
            axiosInstance.defaults.errorHandler = {
                errorCallbackFunction: (errorObj) => {
                    console.error('error', errorObj);
                    isModalVisibile.value = true;
                    errorMessage.value = errorObj?.response?.data?.error ?? errorObj?.message;
                },
                errorToast: (errorObj) => {
                    console.error('error', errorObj);
                    toast.add({severity: 'error', summary: errorObj?.response?.data?.error ?? errorObj?.message, life: 5000});
                }
            };

            axiosInstance.defaults.cancelRouting = {
                reportEdition: function (to) {
                    routingCancelModal.value.isVisible = true;
                    routingCancelModal.value.content = 'Budowa dla tego raportu jest nieaktywna, więc nie można przejść do edycji takiego raportu.';
                    routingCancelModal.value.header = 'Brak możliwości edycji raportu.';
                    routingCancelModal.value.label = 'Przejdź do listy raportów';
                    routingCancelModal.value.redirectTo = to;
                }
            };
        });

        const closeRoutingModal = () => {
            routingCancelModal.value.isVisible = false;
            router.push(routingCancelModal.value.redirectTo);
        };

        const redictToLogin = () => {
            isModalVisibile.value = false;
            router.push('/login');
        }

        return { isModalVisibile, errorMessage, routingCancelModal, closeRoutingModal, redictToLogin }
    },

    data() {
        return {
            isLoggedIn: false,
        }
    },
    watch: {
        '$route': function(value) {
            this.isLoggedIn = value.name !== 'Login';
        }
    }
}
</script>

<style lang="scss">
@import 'imports';

html,
body{
    height: 100%;
    overflow: hidden;
}

body {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

#app {
  text-align: center;
  color: #2c3e50;
}

div.mainWrapper {
    display: grid;

    grid-template-areas: "header"
                          "router";

    @include respond-to(768plus){
        grid-template-columns: 2fr 8fr;
        grid-template-rows: 60px 1fr;
        grid-template-areas: "nav header"
                          "nav router";
    }

    @media print{
        grid-template-areas: none;
    }

    & > div.navWrapper{
        grid-area: nav;
        height: 100vh;
        background-color: $color-zodiac;
        display: none;

        @include respond-to(768plus){
            display: block;
        }
    }

    & > div.routerWrapper{
        grid-area: router;
        max-height: calc(100vh - 60px);
        overflow-y: scroll;
        @include miniScrollbar;

        @media print {
            overflow: visible !important;
        }
    }

    & > div.headerWrapper{
        grid-area: header;
    }
}

</style>
